// Abre WhatsApp con el número del cliente y un mensaje precargado.
function normalizeMx(phone) {
  if (!phone) return "";
  let d = String(phone).replace(/\D/g, "");
  if (!d) return "";
  if (d.length === 10) d = "52" + d; // número local MX -> +52
  return d;
}

export function openWhatsApp(phone, message) {
  const num = normalizeMx(phone);
  const text = encodeURIComponent(message || "");
  const url = num
    ? `https://wa.me/${num}?text=${text}`
    : `https://api.whatsapp.com/send?text=${text}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
